var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimelapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9068_216482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5059 8.255C16.2397 7.085 14.5855 6.5 12.9314 6.5V12.5L8.35693 16.745C10.8839 19.09 14.9735 19.09 17.5005 16.745C20.0275 14.4 20.0275 10.6 17.5059 8.255ZM12.9314 2.5C6.97759 2.5 2.15527 6.975 2.15527 12.5C2.15527 18.025 6.97759 22.5 12.9314 22.5C18.8852 22.5 23.7075 18.02 23.7075 12.5C23.7075 6.975 18.8852 2.5 12.9314 2.5ZM12.9314 20.5C8.16835 20.5 4.3105 16.92 4.3105 12.5C4.3105 8.08 8.16835 4.5 12.9314 4.5C17.6944 4.5 21.5523 8.08 21.5523 12.5C21.5523 16.92 17.6944 20.5 12.9314 20.5Z",
    fill: "#FF9500"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9068_216482"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.8627,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimelapse);
export default __webpack_public_path__ + "static/media/timelapse.03f735b94f4472194f2f395c0253ff7a.svg";
export { ForwardRef as ReactComponent };